























import Vue from 'vue';
import { Deck, Card } from '@/types';
import { v4 as uuid } from 'uuid';

export default Vue.extend({
  data() {
    return {
      newTitle: '' as string,
    };
  },
  methods: {
    createDeck: function() {
      const newDeck = {
        cards: [] as Card[],
        title: this.newTitle,
        updatedAt: new Date().getTime(),
        _id: uuid(),
      } as Deck;
      this.$emit('createDeck', newDeck);
      this.newTitle = '';
    },
  },
});
